.rate-type-rate-trend-card{display:block}
/*# sourceMappingURL=rate-type-rate-trend.component-JE372XBB.css.map */
